var RoundProgressModule = /** @class */ (function () {
    function RoundProgressModule() {
    }
    return RoundProgressModule;
}());
export { RoundProgressModule };
